import { ShieldExclamationIcon } from '@heroicons/react/24/outline'
import { humanToolName } from '../../lib/messageContent'
import ChoicePrompt from './ChoicePrompt'
import { useChat } from '../../providers/chat/context'

const CHIP = 'rounded-md bg-stone-200 px-1.5 py-px text-[10px] font-medium text-stone-600'

function creditsLabel(credits: number) {
  if (credits <= 0) return null
  return credits < 1 ? '< 1 credit' : `~${Math.round(credits)} credit${credits >= 2 ? 's' : ''}`
}

export default function PermissionPrompt() {
  const { pendingPermission, busy, decide } = useChat()
  if (!pendingPermission) return null

  const credits = creditsLabel(pendingPermission.estimated_cost_credits)
  const disabled = busy === 'deciding'

  return (
    <ChoicePrompt
      icon={<ShieldExclamationIcon className="size-3.5 text-purple-700" />}
      title={<span className="capitalize">{humanToolName(pendingPermission.tool_name)}</span>}
      description="This needs your approval before it runs."
      actions={[
        { label: 'Deny', variant: 'muted', disabled, onClick: () => void decide('deny') },
        { label: 'Always allow', variant: 'outline', disabled, onClick: () => void decide('always') },
        { label: 'Allow once', variant: 'primary', disabled, onClick: () => void decide('once') },
      ]}
    >
      <div className="mt-1.5 flex flex-wrap gap-1">
        <span className={`${CHIP} capitalize`}>{pendingPermission.action}</span>
        {credits && <span className={CHIP}>{credits}</span>}
      </div>
    </ChoicePrompt>
  )
}
